import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { OptionsModalEnum } from 'src/app/common/options-modal';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { CompanyClosure } from 'src/app/models/company.model';
import { PayrollRequest } from 'src/app/models/payroll.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { FormTaxResponse } from 'src/app/models/tax.model';
import { CompanyService } from 'src/app/services/company.service';
import { HumanResourcesService } from 'src/app/services/human-resources.service';
import { PayrollService } from 'src/app/services/payroll.service';
import { TaxService } from 'src/app/services/tax.service';
@Component({
  selector: 'app-rrhh-payroll',
  templateUrl: './rrhh-payroll.component.html',
  styleUrls: ['./rrhh-payroll.component.scss']
})
export class RrhhPayrollComponent {
  years: number[] = [];
  year: number = null;
  months: any[] = [];
  monthName = {
    1: "Enero",
    2: "Febrero",
    3: "Marzo",
    4: "Abril",
    5: "Mayo",
    6: "Junio",
    7: "Julio",
    8: "Agosto",
    9: "Septiembre",
    10: "Octubre",
    11: "Noviembre",
    12: "Diciembre"
  }
  clousure: [FormTaxResponse[]] = null;
  formsView = null;
  generating = false;

  constructor(
    private toastService: ToastrService,
    private companyService: CompanyService,
    private taxService: TaxService,
    private payrollService: PayrollService,
    private rrhh: HumanResourcesService,
  ) {
    var todayYear = new Date().getFullYear();
    this.year = todayYear;
    for (let i = 2022; i <= todayYear; i++) {
      this.years.push(i);
    }
    this.getAvailableMonths();
  }

  getAvailableMonths() {
    this.months = [];
    var available = new Date().getMonth();
    for (var i = 0; i < 12; i++) {
      this.months.push({
        name: this.monthName[i + 1],
        number: i + 1,
        closureData: {},
        show: (i < available && this.year === new Date().getFullYear()) || this.year !== new Date().getFullYear(),
        closing: new ButtonLoading("btn-success", false, "Realizar Cierre", "fa-check-to-slot")
      });
    }
  }

  ngOnInit(): void {
    this.getHistoryGenerateds();
    this.getAllDepartments()
  }

  goForms(formIndex) {
    this.formsView = this.clousure[formIndex - 1];
  }

  cleanAndGet(){
    this.getAvailableMonths();
    this.getHistoryGenerateds();
    this.getAllDepartments()
  }


  // Datos de las planillas

  PAYROLL_TYPE_MAP: { [key: number]: string } = {
    // TIPOS DE PAGOS
    200: 'SALARIO',
    201: 'AGUINALDO',
    202: 'BONO14',
    203: 'VACACIONES',
    204: 'LIQUIDACION',
  
    // TIPOS DE DESCUENTOS
    300: 'AUSENCIAS',
    301: 'ISR',
    302: 'IGSS',
    303: 'DESCUENTOS ANTICIPO',
    304: 'PRESTAMOS BANCARIOS',
    305: 'DEMANDA JUDICIAL',
    306: 'OTROS DESCUENTOS',
  
    // INGRESOS
    400: 'BONIFICACIÓN INCENTIVO',
    401: 'HORAS EXTRA',
    402: 'COMISIONES',
    403: 'OTRAS BONIFICACIONES',
    404: 'OTROS INGRESOS'
  };

  generatedPayrolls: any [];
  payrollSelected: any = null;
  departments = [];
  summary = null;
  totalAll = 0;
  newPayroll: PayrollRequest = new PayrollRequest();
  payrollSelectedMonth: number = null;

  getHistoryGenerateds() {
    this.payrollService.getGeneratedPayroll(this.year, 4).subscribe({
      next: (response: ResponseObject) => {
        this.generatedPayrolls = response.data;
  
        // Inicializamos meses
        this.months = [];
  
        for (let i = 1; i <= 12; i++) {
          const payrollForMonth = this.generatedPayrolls.find(p => {
            const match = p.header.match(/Pago Mensual numero (\d+)/i);
            if (match && match[1]) {
              const monthNumber = parseInt(match[1], 10) + 1;
              return monthNumber === i;
            }
            return false;
          });
  
          this.months.push({
            name: this.monthName[i],
            number: i,
            payroll: payrollForMonth || null
          });
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }  

  viewPayroll(payroll) {
    const match = payroll.header.match(/Pago Mensual numero (\d+)/i);
    if (match && match[1]) {
      this.payrollSelectedMonth = parseInt(match[1], 10) + 1;
    } else {
      this.payrollSelectedMonth = null; // fallback por si no se detecta
    }
  
    this.payrollSelected = payroll;
  }

  getPayrollTypeText(id: number): string {
    return this.PAYROLL_TYPE_MAP[id] ?? 'DESCONOCIDO';
  }

  generatePayroll(month) {
    console.log("Mes");
    console.log(month.number);
    console.log("Anio");
    console.log(this.year);



  }

  getAllDepartments() {
    this.rrhh.getAllDepartments().subscribe
      (
        {
          next: (response: ResponseObject) => {
            this.departments = response.data;
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error(error.error.message);
          }
        }
      )
  }

  getSummary(month) {
    console.log(month.number);
    this.generating = true;
  
    const startDate = new Date(this.year, month.number - 1, 1); // Primer dia del mes
    const endDate = new Date(this.year, month.number, 0); // Último dia del mes
  
    this.payrollService.getSummaryContract(this.departments[0].id,4,startDate.getTime(),endDate.getTime()).subscribe(
      {
        next: (response: ResponseObject) => {
          this.summary = response.data;
          this.setNewTotal();
          this.generating = false;
          console.log(this.summary);
          this.saveGeneratedPayroll(month);
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
          this.generating = false;
        }
      }
    );
  }  

  saveGeneratedPayroll(month){
    this.newPayroll = new PayrollRequest();
    const startDate = new Date(Date.UTC(this.year, month.number - 1, 1));
    const endDate = new Date(Date.UTC(this.year, month.number, 0));

    // Agregar 6 horas (6 * 60 * 60 * 1000 milisegundos)
    const adjustedStartDate = new Date(startDate.getTime() + 6 * 60 * 60 * 1000);
    const adjustedEndDate = new Date(endDate.getTime() + 6 * 60 * 60 * 1000);

    this.newPayroll.date = adjustedStartDate.toISOString();
    this.newPayroll.endDate = adjustedEndDate.toISOString();
    this.newPayroll.payments = this.summary;
    this.newPayroll.period = adjustedStartDate.toISOString();
    console.log(this.newPayroll);
    this.payrollService.generatePayroll(this.newPayroll).subscribe
    (
      {
        next: (response: ResponseObject) => {
          this.cleanAndGet();
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
        }
      }
    );
  }

  setNewTotal() {
    this.totalAll = 0;
    this.summary.forEach(element => {
      this.totalAll += element.total;
    });
  }
    
  getLastDayOfMonthFromMonthNumber(month: number): Date {
    if (!month || !this.year) return null;
    return new Date(this.year, month, 0); // Día 0 del siguiente mes = último día del mes actual
  }
}
